/**
 * 会員番号に対する共通処理です。
 */
export const memberNumberMixin = {
    methods: {
        /**
         * ゴルフ場のスキャナー機器で読み取り可能な会員番号を取得します。
         * 
         * 会員番号のバーコード、QRコードの生成時に使用します。
         * 
         * @param  { string } golfGroupCode ゴルフグループコード
         * @param  { string } memberNumber 会員番号
         * @return { string } 0埋めした12桁の番号(ゴルフグループコード4桁 + 会員番号8桁) 
         */
        getReadableMemberNumberByScannerDevice: function (golfGroupCode, memberNumber) {
            return golfGroupCode + (('00000000' + memberNumber).slice(-8));
        },
    }
};
